import React from 'react';
import './FeaturedIcon.scss';
import NoDataIcon from '../../../images/no-data-icon.svg';

const FeaturedIcon = () => {
  return <img src={NoDataIcon} className='featured-icon' alt='featured-icon' />;
};

export default FeaturedIcon;
